export const AuthEndpoints = {
  login: process.env['NEXT_PUBLIC_API'] + '/auth/login',
  googleAuthSignup: process.env['NEXT_PUBLIC_API'] + '/auth/google',
  googleAuthSignin: process.env['NEXT_PUBLIC_API'] + '/auth/google/login',
  googleAuthSignupCallback:
    process.env['NEXT_PUBLIC_API'] + '/auth/google/callback',
  googleAuthSigninCallback:
    process.env['NEXT_PUBLIC_API'] + '/auth/google/callback/login',
  cleverAuthSignin: process.env['NEXT_PUBLIC_API'] + '/auth/clever/callback',
  classlinkAuthSignin:
    process.env['NEXT_PUBLIC_API'] + '/auth/classlink/callback',
  shibbolethAuthSignin:
    process.env['NEXT_PUBLIC_API'] + '/auth/shibboleth/callback',
  checkShibboleth:
    process.env['NEXT_PUBLIC_API'] + '/auth/shibboleth/student-login',
  refreshToken: process.env['NEXT_PUBLIC_API'] + '/auth/refresh',
  signup: process.env['NEXT_PUBLIC_API'] + '/auth/signup',
  signupQuestions: process.env['NEXT_PUBLIC_API'] + '/auth/signup/questions',
  verify: process.env['NEXT_PUBLIC_API'] + '/auth/verify',
  createPassword: process.env['NEXT_PUBLIC_API'] + '/auth/verify/new-user',
  resendVerificationEmail:
    process.env['NEXT_PUBLIC_API'] + '/auth/verify/resend-email',
  forgotPassword:
    process.env['NEXT_PUBLIC_API'] + '/auth/passwordRecoveryRequest',
  resetPassword: process.env['NEXT_PUBLIC_API'] + '/auth/passwordReset',
};
